import { Injectable } from '@angular/core';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { Computed, StateRepository } from '@angular-ru/ngxs/decorators';
import { State } from '@ngxs/store';
import { Language, LanguageService } from '@portals/api';

import { finalize, mergeMap, tap } from 'rxjs/operators';

interface StateModel {
	isLoading: boolean;
	data: Language[];
	selected: Language;
}

@StateRepository()
@State<StateModel>({
	name: 'languages',
})
@Injectable()
export class LanguagesState extends NgxsDataRepository<StateModel> {
	@Computed()
	get isLoading() {
		return this.snapshot.isLoading;
	}

	@Computed()
	get hasData() {
		return !!this.snapshot.data;
	}

	@Computed()
	get data() {
		return this.snapshot.data;
	}

	@Computed()
	get item() {
		return this.snapshot.selected;
	}

	constructor(private languageService: LanguageService) {
		super();
	}

	load() {
		this.patchState({ isLoading: true });

		return this.languageService.find().pipe(
			tap(({ data }) => {
				this.patchState({ data });
			}),
			finalize(() => {
				this.patchState({ isLoading: false });
			})
		);
	}

	create(formData: FormData) {
		this.patchState({ isLoading: true });

		return this.languageService.create(formData).pipe(mergeMap(() => this.load()));
	}

	updateLanguage(id: number, payload: FormData) {
		this.patchState({ isLoading: true });

		return this.languageService.update(id, payload).pipe(mergeMap(() => this.load()));
	}
}
